import * as yup from 'yup';

function name(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'NAME_IS_REQUIRED',
        defaultMessage: 'Name is required',
      }),
    )
    .max(
      200,
      formatMessage({
        id: 'NAME_SHOULD_BE_LESS_THAN_200_CHARS',
        defaultMessage: 'Name should be less than 200 chars',
      }),
    );
}

function conditions(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CONDITIONS_IS_REQUIRED',
      defaultMessage: 'Conditions is required',
    }),
  );
}

function outcome(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'OUTCOME_IS_REQUIRED',
      defaultMessage: 'Outcome is required',
    }),
  );
}

function isActive(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'IS_ACTIVE_IS_REQUIRED',
      defaultMessage: 'Is Active is required',
    }),
  );
}

const validationSchema = (formatMessage, getApiUrl, get) =>
  yup
    .object({
      name: name(formatMessage, getApiUrl, get),
      conditions: conditions(formatMessage),
      outcome: outcome(formatMessage),
      isActive: isActive(formatMessage),
    })
    .required();

export default validationSchema;
